
namespace TabAurous.Production {
    export class WIPMovementRowOptions {
        items: TabAurous.Production.WIPMovementRow[];
    }

    export class WIPMovementRowPanel extends Serenity.TemplatedPanel<WIPMovementRowOptions> {
        constructor(container: JQuery, opt: WIPMovementRowOptions) {
            super(container, opt);

            //Grouping
            var items = this.options.items;

            var department = 'DEPT';
            var loss = 0;

            var namearray = [department];
            var dataarray = [loss];
            namearray.pop();
            dataarray.pop();
            for (var i = 0; i < items.length; i++) {
                var exists = false;
                for (var k = 0; k < namearray.length; k++) {
                    if (items[i].DeptName == namearray[k]) {
                        dataarray[k] += items[i].Loss;
                        exists = true;
                    }
                }
                if (!exists) {
                    namearray.push(items[i].DeptName);
                    dataarray.push(items[i].Loss);
                }
            }
            //var ser = [{ name, data }];
            //ser.pop();
            //for (var i = 0; i < namearray.length; i++) {
            //    name = namearray[i];
            //    data = dataarray[i];
            //    var newseries = { name, data };
            //    ser.push(newseries);
            //}
            var options = {
                series: dataarray,
                chart: {
                    type: 'donut',
                },
                labels: namearray,
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 100
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            };

            //var x = document.getElementById('TabAurous_Reports_WIPMovementRowPanel13_chartContainer');
            var y = container[0].childNodes[0];
            var chart = new ApexCharts(y, options);
            chart.render();
        }

        getTemplate() {

            return `<div id="~_chartContainer"></div>`;
        }
    }


    @Serenity.Decorators.registerClass()
    export class LossReportDepartmentWiseGrid extends _Ext.GridBase<WIPMovementRow, any> {
        protected getColumnsKey() { return 'Production.LossReport'; }
        protected getDialogType() { return WIPMovementDialog; }
        protected getIdProperty() { return WIPMovementRow.idProperty; }
        protected getInsertPermission() { return WIPMovementRow.insertPermission; }
        protected getLocalTextPrefix() { return WIPMovementRow.localTextPrefix; }
        protected getService() { return LossReportService.baseUrl; }
        private chartContainer: JQuery;
        private chartPanel: WIPMovementRowPanel;
        constructor(container: JQuery) {
            super(container);
            this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());


            this.view.setGrouping([{
                getter: 'DeptName',

                displayTotalsRow: false

            }])
            return grid;
        }

        onViewProcessData(response: Serenity.ListResponse<WIPMovementRow>) {

            if (!this.chartContainer) {
                this.chartContainer = $("<div style='padding: 20px;width:500px' />");
                this.chartContainer.insertBefore(this.element.find(".grid-container"));
            }

            if (this.chartPanel) {
                this.chartPanel.destroy();
            }

            this.chartPanel = new WIPMovementRowPanel(this.chartContainer, { items: response.Entities });
             

            return response;
        }

        //protected updateInterface() {
        //    super.updateInterface();
        //    this.setTitle("Profit and Loss");
        //}
        protected usePager() { return true; };
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                reportTitle: "Loss Report(Department Wise)"
            }));

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: this.getService() + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            //buttons.push({
            //    title: 'Print',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {

            //        Common.ReportHelper.execute({
            //            reportKey: 'Production.ProfitandLoss',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //                VendorIds: this.view.params.VendorIds,
            //                date: this.view.params.Criteria
            //            }
            //        });
            //    }
            //}
            //);
            return buttons;
        }
    }
}

/*
 * 
 * var options = {
                series: [{
                    name: 'Inflation',
                    data: dataarray
                }],
                chart: {
                    height: 350,
                    widht: 500,
                    type: 'bar',
                },
                plotOptions: {
                    bar: {
                        borderRadius: 10,
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val + "%";
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },

                xaxis: {
                    categories: namearray,
                    position: 'top',
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    crosshairs: {
                        fill: {
                            type: 'gradient',
                            gradient: {
                                colorFrom: '#D8E3F0',
                                colorTo: '#BED1E6',
                                stops: [0, 100],
                                opacityFrom: 0.4,
                                opacityTo: 0.5,
                            }
                        }
                    },
                    tooltip: {
                        enabled: true,
                    }
                },
                yaxis: {
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false,
                    },
                    labels: {
                        show: false,
                        formatter: function (val) {
                            return val + "%";
                        }
                    }

                },
                title: {
                    text: 'Loss Report(Department Wise)',
                    floating: true,
                    offsetY: 330,
                    align: 'center',
                    style: {
                        color: '#444'
                    }
                }
            };
*/